import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import firebaseConfigDev from './firebaseConfigDev';
import firebaseConfig from './firebaseConfig';
import C from "@/c"

const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();

let firebaseApp;
let db;
let auth;
let emailAuthProvider;

if (!firebaseApp || !firebase.apps.length) {
    // let config = C.PRODUCTION ? firebaseConfig : firebaseConfigDev;
    let config = firebaseConfig;
    firebaseApp = firebase.initializeApp(config);
      db = firebaseApp.firestore();
    auth = firebaseApp.auth();
    // this one is a static method
    emailAuthProvider = firebase.auth.EmailAuthProvider;
}

export default {
    db,
    auth,
    emailAuthProvider,
    serverTimestamp
}
